import React from 'react';
import { userAppContext } from '../../context/Context';
import ResetApiKey from '../../services/ResetApiKey';
import { useUserApiKey } from '../../hooks/useUserApiKey';

interface ApiKeyRequest {
  status?: string;
}

interface ProfileApiKeyProps {
  apiKeyClass: string;
}

const ProfileApiKey: React.FC<ProfileApiKeyProps> = ({ apiKeyClass }) => {
  const { user, userApiKey: contextUserApiKey, setUserApiKey: contextSetUserApiKey } = userAppContext();
  const {
    userApiKey,
    userResetApiKey,
    apiKeyRequest,
    isPassVisible,
    copied,
    apiKeyRef,
    isStandard,
    isExternal,
    apiKeyDisplayStatus,
    togglePassVisibility,
    handleResetApiKeyData,
    handleCopy,
    handleDeleteUserApiKeyData,
    setApiKeyRequest,
    setUserResetApiKey,
  } = useUserApiKey({
    user,
    userApiKey: contextUserApiKey,
    setUserApiKey: contextSetUserApiKey,
  });

  const alert = () => {
    if (apiKeyRequest.status === 'OK') {
      return (
        <div className="alert alert-success mt-3" role="alert">
          Successfully reset
        </div>
      );
    } else if (apiKeyRequest.status === 'BAD_REQUEST') {
      return (
        <div className="alert alert-danger mt-3" role="alert">
          Incorrect username or password
        </div>
      );
    }
    return null;
  };

  return (
    <React.Fragment>
      <div className={`${apiKeyClass} `} id="apiKey">
        <p className="input100">Your Rest API Key is: </p>
        <span ref={apiKeyRef} className="label-input100">
          {userApiKey || apiKeyDisplayStatus}
        </span>

        <span className="copy-clip-board"></span>
        {userApiKey && !isStandard && <button onClick={handleCopy} className="fa fa-copy" />}

        {copied && (
          <span style={{ color: 'green' }} className="copy label-input100 ">
            {' '}
            Copied!
          </span>
        )}

        <div className="wrap-input100" />
        {!isExternal && !isStandard && (
          <button className="input100 resetApiKeyandPass" data-toggle="modal" data-target="#resetApiKeyModal">
            Reset Your API Key
          </button>
        )}
        {!isStandard && (
          <div
            className="modal apiKeyModal"
            id="resetApiKeyModal"
            tabIndex={-1}
            role="dialog"
            aria-labelledby="resetApiKeyModal"
            aria-hidden="false"
          >
            <div className="modal-dialog  modal-dialog-centered" role="document">
              <div className="modal-content modal-sm">
                <div className="modal-header">
                  <h5 className="modal-title" id="resetApiKeyModal">
                    Reset your API Key
                  </h5>
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                    onClick={handleDeleteUserApiKeyData}
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div className="modal-body m-1">
                  <form id="resetForm" onSubmit={handleResetApiKeyData}>
                    {/* <label htmlFor="InputUserName">Email</label> */}
                    {/* <input type="text" className="form-control" id="username" placeholder="Email" required /> */}
                    <div className="password-input">
                      <label className="mt-3" htmlFor="InputPassword">
                        Password
                      </label>
                      <span className="eye-icon-apiReset" onClick={togglePassVisibility}>
                        <i className={`fa ${isPassVisible ? 'fa-eye' : 'fa-eye-slash'}`} aria-hidden="true" />
                      </span>
                    </div>
                    <input
                      type={`${isPassVisible ? 'text' : 'password'}`}
                      className="form-control"
                      id="password"
                      name="password"
                      placeholder="password"
                      required
                    />
                    <div className="text-center">
                      {apiKeyRequest.status === 'OK' ? (
                        <button
                          type="button"
                          className="button BtnAccion p-2 px-3 justify-content-center"
                          data-dismiss="modal"
                          onClick={handleDeleteUserApiKeyData}
                        >
                          Close
                        </button>
                      ) : (
                        <button type="submit" className="button BtnApyKey p-2 px-3 justify-content-center">
                          Submit
                        </button>
                      )}
                    </div>
                  </form>
                  {alert()}
                </div>
              </div>
            </div>
          </div>
        )}
        {!isStandard && <ResetApiKey setApiKeyRequest={setApiKeyRequest} userResetApiKey={userResetApiKey} />}
      </div>
    </React.Fragment>
  );
};

export default ProfileApiKey;
